// Bootstrap 5 custom validation — auto-wires any <form class="needs-validation">.
// Standard BS5 pattern (https://getbootstrap.com/docs/5.3/forms/validation/#custom-styles):
// on submit, if the form is invalid we block the submit and add `was-validated`
// so BS5's CSS shows red borders + .invalid-feedback messages under each field.
//
// One handler covers every form on the page. Used by bseeform's required fields,
// but works for any hand-rolled BS5 form too.

function attach(form: HTMLFormElement): void {
    if (form.dataset.bseeValidationBound === '1') {
        return;
    }
    form.dataset.bseeValidationBound = '1';

    form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            // Scroll the first invalid control into view for long forms.
            const firstInvalid = form.querySelector<HTMLElement>(':invalid');
            if (firstInvalid) {
                firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        form.classList.add('was-validated');
    });
}

function scan(): void {
    document.querySelectorAll<HTMLFormElement>('form.needs-validation').forEach(attach);
}

export const bseeValidation = { attach, scan };

document.addEventListener('DOMContentLoaded', () => {
    scan();
});
